/**
 * 隐私政策同意状态（与 App.vue / 原生 SharedPreferences 保持一致）
 */
export const PRIVACY_AGREED_KEY = 'privacyAgreementAgreed';

export function hasPrivacyAgreement() {
  try {
    if (typeof localStorage === 'undefined') return false;
    return localStorage.getItem(PRIVACY_AGREED_KEY) === 'true';
  } catch (e) {
    return false;
  }
}

export function isNativeApp() {
  try {
    if (typeof document !== 'undefined' && document.body?.classList?.contains('capacitor-app')) {
      return true;
    }
    const cap = typeof window !== 'undefined' ? window.Capacitor : null;
    return !!(cap && typeof cap.isNativePlatform === 'function' && cap.isNativePlatform());
  } catch (e) {
    return false;
  }
}

/** 原生 App 且用户尚未同意隐私政策 */
export function needsPrivacyConsent() {
  return isNativeApp() && !hasPrivacyAgreement();
}
